import { container } from '@graphistry/falcor-react-redux';
import KeplerDropdownComponent from '@graphistry/viz/src/components/kepler-dropdown/index.tsx';

type ModeType = 'graph' | 'hybrid' | 'kepler';

interface KeplerData {
    enabled?: boolean;
    mode?: ModeType;
    dropdownVisible?: boolean;
}

interface NodeEncodings {
    bindings?: {
        node_longitude?: string;
        node_latitude?: string;
    };
}

interface Column {
    name: string;
    dataType: string;
    componentType: string;
}

interface ModeMap {
    [key: string]: string;
}

// backend converts numeric types to number or int
function isNumeric(dataType: string): boolean {
    return dataType === 'number' || dataType === 'integer';
}

function hasValidMapsColumns(nodeEncodings?: NodeEncodings, columns?: Column[]): boolean {
    if (!columns || columns.length === 0) return false;

    const bindings = (nodeEncodings && nodeEncodings.bindings) || {};
    const longitudeName = bindings.node_longitude || 'longitude';
    const latitudeName = bindings.node_latitude || 'latitude';

    const nodeColumns = columns.filter(col => col.componentType === 'point');

    const longitudeColumn = nodeColumns.find(col => col.name === longitudeName);
    const latitudeColumn = nodeColumns.find(col => col.name === latitudeName);

    if (!longitudeColumn || !latitudeColumn) return false;

    return isNumeric(longitudeColumn.dataType) && isNumeric(latitudeColumn.dataType);
}

const KeplerDropdownContainer = container({
    renderLoading: false,
    fragment: () => `{
        enabled,
        mode,
        dropdownVisible
    }`,
    mapFragment: (kepler: KeplerData, props: any) => {
        const { selectToolbarItem, columns, dataset } = props;
        const nodeEncodings = {
            bindings: dataset && dataset.nodeBindings
        };

        const hasKeplerEncodings = hasValidMapsColumns(nodeEncodings, columns);

        return {
            enabled: kepler.enabled || false,
            mode: (kepler.mode || 'graph') as ModeType,
            dropdownVisible: kepler.dropdownVisible || false,
            hasKeplerEncodings,
            onSelectMode: (mode: ModeType) => {
                const modeMap: ModeMap = {
                    'graph': 'toggle-kepler-graph',
                    'hybrid': 'toggle-kepler-hybrid',
                    'kepler': 'toggle-kepler-map'
                };
                return selectToolbarItem({ id: modeMap[mode], selected: true });
            },
            onToggleDropdown: () => selectToolbarItem({ id: 'toggle-kepler-dropdown', selected: true })
        };
    }
})(KeplerDropdownComponent);

export const KeplerDropdown = KeplerDropdownContainer;
